import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { PageLoader } from '@/components/common/page-loader';
import { ErrorState } from '@/components/common/error-state';
import { LegalConsentGate } from '@/components/legal/legal-consent-gate';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthed, isBooting, isUserLoading, isUserError, refetchUser, user } = useAuth();
  const loc = useLocation();
  if (isBooting) return <PageLoader />;
  if (!isAuthed) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (isUserLoading) return <PageLoader />;
  if (isUserError || !user) {
    return (
      <div className="mx-auto flex min-h-screen max-w-lg items-center px-4">
        <ErrorState
          message="Не удалось проверить профиль и актуальность согласий"
          onRetry={() => void refetchUser()}
        />
      </div>
    );
  }
  if (!user.legal_consents_current) return <LegalConsentGate />;
  return <>{children}</>;
}
